<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Ticket History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">My Chat</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <!-- <div class="card-header">
                <h3 class="card-title">My Orders</h3>
                <div class="card-tools">
                </div>
              </div> -->

              <!-- <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div> -->

              <div class="card-body p-0">
                <div
                  class="chat_history container"
                  v-for="(val, index) in list.data"
                  :key="index"
                  v-bind:class="{ darker: !isCustomer(val.chat_member_name) }"
                >
                  <img
                    alt="Avatar"
                    v-if="isCustomer(val.chat_member_name)"
                    v-bind:src="
                      isCustomer(val.chat_member_name) ? profile.avatar : ''
                    "
                    class="img-circle img-size-50 right"
                  />
                  <img
                    v-else
                    src="../../../public/img/agent.png"
                    class="img-circle img-size-50"
                  />
                  <p>{{ val.message }}</p>
                  <span
                    v-bind:class="{
                      'time-right': !isCustomer(val.chat_member_name),
                    }"
                    >{{ val.message_time }}</span
                  >
                </div>

                <div
                  class="p-4"
                  v-if="_.isEmpty(list.data) && !list.is_loading"
                >
                  <div class="alert alert-default-warning" role="alert">
                    No Chat found!
                  </div>
                </div>
              </div>

              <!-- <div class="card-footer">
                <vue-pagination
                  :pagination="list"
                  v-if="list.total > list.per_page"
                  @paginate="getList()"
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
.chat_history {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}

.darker {
  border-color: #ccc;
  background-color: #ddd;
}

.chat_history::after {
  content: "";
  clear: both;
  display: table;
}

.chat_history img {
  float: left;
  max-width: 60px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
}

.chat_history img.right {
  float: right;
  margin-left: 20px;
  margin-right: 0;
}

.time-right {
  float: right;
  color: #aaa;
}

.time-left {
  float: left;
  color: #999;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI, SelfcareAPI } from "@/services/api";

const fileDownload = require("js-file-download");
import { Notification } from "element-ui";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MyChat",
  metaInfo: {
    title: "MyChats | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    list: {
      is_loading: true,
      data: [],
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }

      // window.$(document).find('.push-menu-class').trigger('click');
    }

    // this.api_url = "/ticketList";
    this.getList();
    console.log("Profile::", this.profile);
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getList();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    ...mapActions(["FETCH_PROFILE"]),
    customFormatter(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },

    isCustomer(name) {
      let loggedInCustomer =
        this.profile.first_name + " " + this.profile.last_name;
      loggedInCustomer = loggedInCustomer.trim();
      if (loggedInCustomer.includes(name.trim())) {
        return true;
      } else {
        return false;
      }
    },
    getList() {
      let _this = this;
      //  _this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      query.cuid = subscriber ? subscriber.id : null;

      SelfcareAPI.getMyChatHistory(query)
        .then((response) => {
          _this.list.is_loading = false;
          _this.list = response;
        })
        .catch((error) => {})
        .finally(() => {
          _this.list.is_loading = false;
        });
    },

    apiUsage(query = null) {},

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getList();
    },
  },
};
</script>
